import React from 'react';
import { AsyncSelect } from 'lib/releox-react';
import apis from '../../configs/apis';

export default () => (
  <AsyncSelect label="Caller" name="callerId" getUrl={apis.MEMBER} searchFields={['name']} />
);
